module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/2@2x_3eb1b177ed5a47272ca2220af4a9c5d8.png";